import React, { useState, useEffect } from "react";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import axiosInstance from "../../../../Services/axiosCommon";

import {
  NuDate,
  NuInput,
  NuMobileNumber,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import MultiSelect, { MultiSelectTwo } from "../../../../Components/Utils/MultiSelect";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import { useToast } from "../../../../Components/Others/ToastServices";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import EditIcon from "../../../../Components/Icons/Edit";
import UseSupplierDropDownNew from "../../../../Components/Hooks/useSupplierSearch";
import DeleteIcon from "../../../../Components/Icons/Delete";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];

function CreateFireSuppresion() {
  const { data: user } = UseDropDown(`/user/new-drop-down`);
const { data: contract } = UseDropDown(`/contract/drop-down`);

const { data: client, setDataCustomer } = UseCustomerDropDownNew(
  "/clients/drop-down",
  // searchClient
);

const { value: Approved, getData: refApproved } = useFetchMataData(
  `/dropdown/dropdown-details/`,
  "Approved_FireExtinguisher"
);
  const { isLoading, Oncancel, addFormData, contextHolder } = useAddFormData();
  const [searchSupplier, setSearchSupplier] = useState("");
 
  
  const toast = useToast();

  const [createNew, setCreateNew] = useState({
            type:2,
          contractId :"", 
          deliveredBy:"",
          equipments :[] ,
          collectors:[],
          attachments:[],
          approvedBy:"",
          countryCode:"",
          phone:"",
  });

  const [isEditQua, setIsEditQua] = useState(false);

  const [error, setError] = useState("");
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
         contractId: yup.string().required("ContractId is requred!"),
         clientId: yup.string().required("ClientId is requred!"),
   
       }),
    onSubmit: async (value, { resetForm }) => {
      // if (crlist.length === 0) {
      //   setError("Product table is empty");
      //   return;
      // }
      let formData = new FormData();

      const valueWithItems = {
        ...value,
        // equipments: crlist,
      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
            await addFormData({url:`/collection-and-returns/new-cr`, formData:formData,navigateUrl:`/Contract-management/fireSuppression`,resetForm:resetForm   });

      // addFormData("/collection-and-returns/new-cr", formData, resetForm);
    },
  });

  const [crlist, setcrlist] = useState([]);

  const getcr = (contractId) => {
    if (contractId !== "") {
      axiosInstance
        .get(`/contract/equipments/${contractId}`)
        .then((res) => {
          let data = res.data;
          setcrlist(data);
        })
        .catch((err) => {
          console.log(err, "err");
        });
    }
  };

  // const getCustomerRef = (contractId) => {
  //   if (contractId !== "") {
  //     axiosInstance
  //       .get(`/rfq/customer-ref/${contractId}`)
  //       .then((res) => {
  //         let data = res.data.data;
  //         formik?.setFieldValue("customerRfq", data);
  //       })
  //       .catch((err) => {
  //         console.log(err, "err");
  //       });
  //   }
  // };

  // useEffect(() => {
  //   if (crlist.length > 0) {
  //     setError("");
  //   }
  // }, [crlist]);

  useEffect(() => {
    if (formik.values.contractId) {
      getcr(formik.values.contractId);
    }
    // if (formik.values.contractId) {
    //   getCustomerRef(formik.values.contractId);
    // }
  }, [formik.values.contractId]);

  const [deletedItem, setDeletedItem] = useState([]);
  const [deletedItemDropDown, setDeletedItemDropDown] = useState([]);

  const handleDeleteItem = (indexToDelete) => {
    const updatedItems = crlist.filter((_, index) => index !== indexToDelete);
    setcrlist(updatedItems);
    const deletedItems = crlist.filter((_, index) => index == indexToDelete);
    setDeletedItem((prevDeletedItems) => [
      ...prevDeletedItems,
      ...deletedItems,
    ]);
  };
  useEffect(() => {
    let tempData = [];
    deletedItem.forEach((item) => {
      let tempObject = { value: item.productId, label: item.product_name };
      tempData.push(tempObject);
    });
    setDeletedItemDropDown(tempData);
  }, [deletedItem]);

  // const handleAdd = () => {
  //   const selectedProductId = formik.values.productId;

  //   const selectedProduct = deletedItem.find(
  //     (item) => item.productId === selectedProductId
  //   );

  //   if (selectedProduct) {
  //     setcrlist((prevcrlist) => [...prevcrlist, selectedProduct]);

  //     setDeletedItem((prevDeletedItems) =>
  //       prevDeletedItems.filter((item) => item.productId !== selectedProductId)
  //     );
  //   }
  // };



  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState([]);

   function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };

  const handleQuantityChange = (e, index) => {
    const updatedItems = [...crlist];
    updatedItems[index].quantity = e.target.value;
    setcrlist(updatedItems);
  };

  const getCustomerRef = (id) => {
    if (id !== "") {
      axiosInstance
        .get(`/contract/${id}`)
        .then((res) => {
          let data = res.data.data;
          formik?.setFieldValue("clientId", data.clientId);

        })
        .catch((err) => {
          console.log(err, "err");
        });
    }
  };

  useEffect(() => {
    // if (formik.values.prId) {
    //   getPr(formik.values.prId);
    // }
    if (formik.values.contractId) {
      getCustomerRef(formik.values.contractId);
    }
  }, [formik.values.contractId]);

  return (
    <div className="w-full h-full py-2 px-4">
       <div className="flex justify-between w-full">  
       <Breadcrumb
          items={[
 
            
            {
              name: "Fire Suppression",
              link:"/Contract-management/fireSuppression"
             
            },

            { name: "Create" },
          ]}
        />    
                <BackButton />
              </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-155px)] bg-white rounded-md overflow-hidden mt-4">
        <div className="w-full ml-3">
                                         <SettingHeading title="Fire Suppression"  />

              </div>
          <div className="w-full h-full py-4 px-3 flex justify-start content-start flex-wrap overflow-y-auto">
          <FormikSelectTwo
                label="Contract "
                Options={contract}
                formik={formik}
                placeholder="Choose"
                name="contractId"
                isRequired={true}
  
                width="w-full md:w-1/3 md:-mt-2"
                FixPosition={true}
                PortalTarget={false}
              />

{formik.values.contractId && (
  <FormikSelectTwo
    label="Client"
    placeholder="Client"
    Options={client}
    formik={formik}
    name="clientId"
    isRequired={true}
    width="w-full md:w-1/3 md:-mt-2"
    disabled={true}
  />
)}

<NuDate
                             label="Collected Date"
                             formik={formik}
                             name="collectedOn"
                             width="w-full md:w-1/3 md:-mt-2"
                           />
                           

               <MultiSelect
                label="Collected By"
                Options={user}
                formik={formik}
                placeholder="Collected By"
                name="collectors"
                // isRequired={true}
  
                width="w-full md:w-1/3"
              />

{/* <DropDownAddMetaData
              label="Approved By"
              placeholder="Choose"
              Options={Approved}
              formik={formik}
              name="approvedBy"
              width="w-full md:w-1/2 lg:w-1/3 md:-mt-1"
              getFunc={refApproved}
              displayProperty={"Approved By"}
              propertyName={"Approved_FireExtinguisher"}
              FixPosition={true}
              PortalTarget={false}
            />

               <NuMobileNumber
                               nunCode="countryCode"
                               label="Phone"
                               placeholder="Phone"
                               formik={formik}
                               name="phone"
                               width="w-full md:w-1/2 lg:w-1/3"
                             /> */}

{/* <NuDate
                             label="Return Date"
                             formik={formik}
                             name="deliveredOn"
                             width="w-full md:w-1/3"
                           />

<FormikSelectTwo
                label="Delivered By"
                Options={user}
                formik={formik}
                placeholder="Delivered By"
                name="deliveredBy"
                // isRequired={true}
  
                width="w-full md:w-1/3"
              /> */}
            {/* <NuInput
              label="Customer Reference"
              type="text"
              formik={formik}
              placeholder="Customer Reference"
              name="customerRfq"
              width="w-full md:w-1/2 lg:w-1/3"
              disabled={true}
            /> */}
           
          

         

         
         
            {/* <NuTextArea
              label="Comments"
              type="text"
              formik={formik}
              placeholder="Comments"
              name="comments"
              width="w-full md:w-1/2 lg:w-2/3"
              new_width="w-full md:w-1/2 lg:w-2/3"
            /> */}
            <div className="w-full">
                                      <SettingHeading title="Attachments"  />

            </div>
            <Attachement
              handleChange={handleImageChange}
              preview={image || ""}
              width="w-full"
              label="Attach"
              multiple={true}
              removeImages={removeImages}
            />

            {/* <div className="w-full h-[1px] opacity-30 bg-[#C4C2C2] my-6 mx-auto"></div>
            {deletedItemDropDown.length > 0 ? (
              <div className="w-full flex justify-start gap-2"> */}
                {/* <FormikSelectTwo
                  type="text"
                  label="Product"
                  placeholder="Product"
                  Options={deletedItemDropDown}
                  formik={formik}
                  name="productId"
                  width="w-full md:w-1/2 lg:w-[67%]"
                /> */}
                {/* <button
                  onClick={handleAdd}
                  type="button"
                  className=" p-1 mt-[44px] m-1 text-center h-8 cursor-pointer bg-[#048178] border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                >
                  Add
                </button> */}
              {/* </div>
            ) : null} */}
            {/* <div className="w-full bg-white overflow-y-scroll mt-5">
              {error && (
                <p className="text-xs font-semibold text-red-500">{error}</p>
              )}
              <div className="w-full py-2 bg-textColor-main flex justify-between rounded-lg px-6">
                <p className="w-[5%]  text-left  text-white text-xs font-medium">
                  S.No{" "}
                </p>
                <p className="w-[10%] text-left text-white text-xs font-medium">
                Name
                </p>
                <p className="w-[10%] text-left text-white text-xs font-medium">
                Brand
                </p>
                <p className="w-[10%] text-center text-white text-xs font-medium">
                Model
                </p>
                <p className="w-[20%] text-center text-white text-xs font-medium flex justify-center">
                  Quantity
                  <span
                    className="pl-1 cursor-pointer"
                    onClick={() => {
                      setIsEditQua((prv) => !prv);
                    }}
                  >
                    {isEditQua === true && (
                      <EditIcon width={"14"} height={"14"} color="yellow" />
                    )}
                    {isEditQua === false && (
                      <EditIcon width={"14"} height={"14"} />
                    )}
                  </span>
                </p>
                <p className="w-[10%] text-center text-white text-xs font-medium">
                Unit
                </p>
                <p className="w-[5%] text-center text-white text-xs font-medium">
                  Action
                </p>
              </div>
              {crlist?.length > 0 ? (
                <div className="h-[calc(100vh-300px)] overflow-y-scroll">
                  {crlist.map((List, index) => (
                    <div
                      key={index}
                      className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                    >
                      <p className="w-[5%]  text-left  text-[#606279] text-xs font-light py-1">
                        {index + 1}
                      </p>
                      <p className="w-[10%] text-left text-[#606279] text-xs font-light">
                        {List?.name}
                      </p>
                      <p className="w-[10%] text-left text-[#606279] text-xs font-light">
                        {List?.brand}
                      </p>
                      <p className="w-[10%] text-center text-[#606279] text-xs font-light">
                        {List?.model}
                      </p>
                      <p className="w-[20%] text-center text-[#606279] text-xs font-light">
                        <input
                          type="number"
                          className="w-full outline-none text-center"
                          name="quantity"
                          formik={formik}
                          value={List?.quantity || ""}
                          disabled={!isEditQua}
                          onChange={(e) => handleQuantityChange(e, index)}
                        />
                      </p>
                      <p className="w-[10%] text-center text-[#606279] text-xs font-light">
                        {List?.unit}
                      </p>
                    
                      <div className="w-[5%] text-center">
                        <button
                          onClick={() => handleDeleteItem(index)}
                          type="button"
                          className="text-red-500 cursor-pointer ml-4 border-none"
                        >
                          <DeleteIcon color="red" height={12} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="w-full text-center text-[#93949f]">
                  No Items here
                </div>
              )}
            </div> */}
             <div className="w-full mx-auto my-4 mt-8 pb-2">
             <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
                <CancelButton
                  handleClick={() => {
                    Oncancel(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </form>
     
      {/* {showPurchaserPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-normal text-[12px]">
              Add Local Purchaser
            </h2>
            <form onSubmit={handlePopupPurchaserSubmit}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  type="text"
                  label="Name"
                  placeholder="Enter Name"
                  formik={formik}
                  name="name"
                  isRequired={true}
                  width="w-full md:w-1/3 md:-mt-2"
                />
                <NuInput
                  type="email"
                  label="Email"
                  placeholder="Email"
                  formik={formik}
                  name="email"
                  isRequired={true}
                  width="w-full md:w-1/3 md:-mt-2"
                />
                <NuMobileNumber
                  nunCode="countryCode"
                  label="Phone"
                  placeholder="Phone"
                  formik={formik}
                  name="phone"
                  width="w-full md:w-1/3 md:-mt-2"
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePurchaserPopup}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                  rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-[#048178] px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )} */}
    </div>
  );
}

export default CreateFireSuppresion;
